import styled from 'styled-components';

export const RightSectionStyled = styled.div`
  margin: 0 auto;
  padding: 0 2rem 5rem;
  max-width: 92rem;
  min-height: 80%;
  position: relative;
`;
